import React, { InputHTMLAttributes, useState } from 'react';

import './ColorPicker.scss';
import { InputText } from 'primereact/inputtext';

const ColorPicker: React.FC<InputHTMLAttributes<HTMLInputElement>> = props => {
	const [value, setValue] = useState(props.value);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const regex = /^#[0-9a-fA-F]*$/;
		let value = e.target.value;
		if (value.length > 0 && !value.startsWith('#')) value = `#${value}`;
		if ((!regex.test(value) && value.length > 0) || value.length > 7) return;
		setValue(value);
	};

	return (
		<div className='p-inputgroup flex  w-8rem'>
			<InputText
				value={value}
				onChange={handleChange}
				className='p-inputtext-sm p-2'
				onFocus={e => e.target.select()}
			/>
			<input
				type='color'
				{...props}
				value={value}
				onChange={handleChange}
				className={'color-picker p-inputgroup-addon'}
			/>
		</div>
	);
};

export default ColorPicker;
